exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HelloA_hello_2KE7x{color:orange}", ""]);

// exports
exports.locals = {
	"hello": "HelloA_hello_2KE7x"
};